import script from "./UnderLineInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnderLineInput.vue?vue&type=script&setup=true&lang=ts"

import "./UnderLineInput.vue?vue&type=style&index=0&id=fa7e8e1a&scoped=true&lang=scss"
import "./UnderLineInput.vue?vue&type=style&index=1&id=fa7e8e1a&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa7e8e1a"]])

export default __exports__